import './App.css';
import Sidebar from './common/Sidebar';
import GOTop from './common/GOTop';
import Main from './pages/main/Main';
import Login from './pages/Login';
import Logout from './pages/Logout';
import PrivateRoute from './auth/PrivateRoute';

import Pos from './pages/pos/Pos';
import PosCalculatorReview from './pages/pos/PosCalculatorReview';
import ProductList from './pages/product/ProductList';
import ProductRegist from './pages/product/ProductRegist';
import ProductInventory from './pages/product/ProductInventory';

import UserAttendance from './pages/user/UserAttendance';
import UserRegist from './pages/user/UserRegist';
import UserList from './pages/user/UserList';
import UserListDealer from './pages/user/UserListDealer';
import UserMembershipCard from './pages/user/UserMembershipCard';

import SalesDay from './pages/sales/SalesDay';
import SalesDealer from './pages/sales/SalesDealer';
import SalesDealerSettlement from './pages/sales/SalesDealerSettlement';
import StatisticsDailySales from './pages/statistics/StatisticsDailySales';
import StatisticsManufactureProduct from './pages/statistics/StatisticsManufactureProduct';
import StatisticsMonthly from './pages/statistics/StatisticsMonthly';
import StatisticsDayOfWeek from './pages/statistics/StatisticsDayOfWeek';
import StatisticsHourly from './pages/statistics/StatisticsHourly';
import StatisticsCategory from './pages/statistics/StatisticsCategory';
import AttendanceCheck from './pages/AttendanceCheck';

import BarcodeTest from './pages/BarcodeTest';

import CacheArrange from './pages/manage/CacheArrange';
import CategorySettings from './pages/settings/CategorySettings';
import GradeSettings from './pages/settings/GradeSettings';

import Footer from './common/Footer';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';



function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  // 로그인 페이지는 별도로 처리
  if (isLoginPage) {
    return <Login />;
  }

  return (
    <>
    <Sidebar />
    <main id="main" className="main">
    {/*<Header />*/}
    {/*<Pagetitle />*/}
    <section className="section">
      <Routes>
        {/* 보호된 라우트 */}
        <Route element={<PrivateRoute />}>
          {/* 메인 */}
          <Route path="/" element={<Main />} />

          {/* POS */}
          <Route path="/pos" element={<Pos />} />
          <Route path="/pos/review" element={<PosCalculatorReview />} />

          {/* 상품 관리 */}
          <Route path="/product/list" element={<ProductList />} />
          <Route path="/product/regist" element={<ProductRegist />} />
          <Route path="/product/:productCode" element={<ProductRegist />} />
          <Route path="/product/inventory" element={<ProductInventory />} />

          {/* 회원 관리 */}
          <Route path="/user/attendance" element={<UserAttendance />} />
          <Route path="/user/list" element={<UserList />} />
          <Route path="/user/dealer" element={<UserListDealer />} />
          <Route path="/user/regist" element={<UserRegist />} />
          <Route path="/user/:userCode" element={<UserRegist />} />
          <Route path="/user/membership/:userCode" element={<UserMembershipCard />} />

          {/* 판매 */}
          <Route path="/sales/day" element={<SalesDay />} />
          <Route path="/sales/dealer" element={<SalesDealer />} />
          <Route path="/sales/dealer/settlement" element={<SalesDealerSettlement />} />

          {/* 통계 */}
          <Route path="/statistics/daily" element={<StatisticsDailySales />} />
          <Route path="/statistics/monthly" element={<StatisticsMonthly />} />
          <Route path="/statistics/day-of-week" element={<StatisticsDayOfWeek />} />
          <Route path="/statistics/hourly" element={<StatisticsHourly />} />
          <Route path="/statistics/category" element={<StatisticsCategory />} />
          <Route path="/statistics/manufacture/product" element={<StatisticsManufactureProduct />} />

          {/* 관리 */}
          <Route path="/manage/cache/arrange" element={<CacheArrange />} />

          {/* 설정 */}
          <Route path="/code/category" element={<CategorySettings />} />
          <Route path="/code/member/grade" element={<GradeSettings />} />

          {/* 기타 */}
          <Route path="/barcodeCreate/:barcode" element={<BarcodeTest />} />
          <Route path="/attendance" element={<AttendanceCheck />} />

          {/* 로그아웃 */}
          <Route path="/logout" element={<Logout />} />
        </Route>
      </Routes>
    </section>
    <GOTop />
    </main>
    <Footer />
    </>
  );
}

export default App;
